import React from "react";
import { withCookie } from "next-cookie";
import AuthNavbar from "./AuthNavbar";
import DefaultNavbarV2 from "./DefaultNavbarV2";
import { UserProvider } from "../../utils/UserContext";

const Navbar = withCookie(({ authenticated, cookie }) => {
  const user = cookie.get("user");
  const authenticationType = cookie.get("authenticationType");
  return !authenticated ? (
    <DefaultNavbarV2 />
  ) : (
    <UserProvider user={{ ...user, authenticationType }}>
      <AuthNavbar />
    </UserProvider>
  );
});

export default Navbar;
